import { Layout } from 'antd';
import { t } from 'i18next';
import styles from 'src/app/components/FooterComponent/FooterComponent.module.scss';
import { LAYOUTVIEW } from 'src/configs/system.config';
import { LayoutViewType } from 'src/enums/user.enum';
import { Footer as FooterTheme } from 'src/theme/Footer.styled';

const { Footer } = Layout;

const FooterComponent = () => {
  return (
    <FooterTheme>
      <Footer className={styles.footerContainer}>
        <div className={styles.footerText}>
          {LAYOUTVIEW() === LayoutViewType.SC3_LAYOUT ? (
            <div className={styles.footerTextContainer}>{t('sidebar.footer.SC3text')}</div>
          ) : (
            <div className={styles.footerTextContainer}>
              <span>{t('sidebar.footer.SAMAtextOne')}</span>
              <img src="/logo_nginr.png" alt="" className={styles.nginrTextLogo} />
            </div>
          )}
        </div>
        {LAYOUTVIEW() === LayoutViewType.SC3_LAYOUT && (
          <div className={styles.footerButtons}>
            <div className={styles.footerButton}>
              <span className={styles.footerButtonText}>{t('sidebar.footer.credits')}</span>
            </div>
            <div className={styles.footerButton}>
              <span className={styles.footerButtonText}>{t('sidebar.footer.termsOfUse')}</span>
            </div>
          </div>
        )}
      </Footer>
    </FooterTheme>
  );
};

export default FooterComponent;
